// extracted by mini-css-extract-plugin
export var condense = "FactSheet-module--condense--5e8d9";
export var fact = "FactSheet-module--fact--68ec2";
export var factCount = "FactSheet-module--factCount--d62fc";
export var factDescription = "FactSheet-module--factDescription--03d9b";
export var factIcon = "FactSheet-module--factIcon--9fbd5";
export var headerLevel2 = "FactSheet-module--headerLevel2--ef4a0";
export var withIcon = "FactSheet-module--withIcon--a4d7b";